import { useTranslation } from "react-i18next";
import Button from "../../../components/buttons/button";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { useState } from "react";
import Popup from "../../../components/popups/popup";
import AddEmployee from "./addEmployee";
import EditEmployee from "./editEmployee";
import MessagePopup from "../../../components/popups/messagePopup";
import DeleteEmployee from "./deleteEmployee";
import Paginate from "../../../components/pagination/paginate";
import SearchSelect from "../../../components/select/searchSelect";
import { useOptions } from "../../../components/hooks/useOptionsHook";
import SearchEmployees from "./searchEmployees";
import EmployeesTable from "./employeesTable";

const Employees = () => {
  const { t } = useTranslation();
  const [openAdd, setOpenAdd] = useState(false);
  const [selected, setSelected] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const data = { last_page: 10 };
  const { paginationOptions } = useOptions();
  return (
    <main>
      <div className="flex flex-wrap items-center justify-between md:flex-nowrap">
        <h1 className="mb-3 text-lg font-bold capitalize md:text-2xl text-primary">
          {t("employeesManagement")}
        </h1>
        <Button
          onClick={() => setOpenAdd(true)}
          className={"bg-primary text-black"}
          type={"button"}
        >
          <AiOutlinePlusCircle />
          {t("addEmployee")}
        </Button>
      </div>
      <article className="mainLinear grid p-4 rounded-[20px] mt-8">
        <SearchEmployees t={t} />
        <EmployeesTable
          t={t}
          setSelected={setSelected}
          setOpenEdit={setOpenEdit}
          setOpenDelete={setOpenDelete}
        />
      </article>
      <div className="flex items-center gap-2">
        <Paginate data={data} />
        <div>
          <SearchSelect
            options={paginationOptions}
            onChange={(e) => {
              alert("now paginating " + e.value);
            }}
            name={"paginate"}
            placeholder={t("show 10")}
          />
        </div>
      </div>
      <Popup open={openAdd} setOpen={setOpenAdd} header={t("addNewMember")}>
        <AddEmployee t={t} setOpen={setOpenAdd} />
      </Popup>

      <Popup open={openEdit} setOpen={setOpenEdit} header={t("editMember")}>
        <EditEmployee t={t} setOpen={setOpenAdd} selected={selected} />
      </Popup>

      <MessagePopup open={openDelete} setOpen={setOpenDelete}>
        <DeleteEmployee t={t} selected={selected} setOpen={setOpenDelete} />
      </MessagePopup>
    </main>
  );
};

export default Employees;
